import React from 'react';
import { Collapse, List } from '@mui/material';
import { AdminPanelSettings, Computer } from '@mui/icons-material';
import SettingsIcon from '@mui/icons-material/Settings';
import { useSidebar } from '../hook/useSidebar';
import SidebarItem from '../SidebarItem';
import SidebarItemExpendable from '../SidebarItemExpendable';
import SidebarItemMore from '../SidebarItemMore';

const Settings: React.FC = () => {
  const { handleCollapseClick, collapsible, setShownUserControl } = useSidebar();
  return (
    <>
      <SidebarItemExpendable
        onClick={() => handleCollapseClick('settings')}
        text="Configurações"
        opened={collapsible.settings}
        icon={<SettingsIcon />}
      />
      <Collapse in={collapsible.settings}>
        <List disablePadding>
          <SidebarItem to="/settings" text="Painel de Controle" nested={5} />

          <SidebarItemMore handleClick={() => setShownUserControl(true)} text="Controle de usuário" nested={5} />
        </List>
      </Collapse>
    </>
  );
};

export default Settings;
